import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { intervalAndValueTypesOptions } from 'App/data-export/store/selectors/intervalAndValueTypesOptions'
import { useMemo } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

export const useIntervalAndValueTypesOptions = (formState: TDataExportStoreState['formState']) => {
  return useMemo(() => {
    return intervalAndValueTypesOptions({
      propertyId: formState.propertyId,
      points: formState.points,
      blockIds: formState.blockIds,
      irrigationZoneEmitterIds: formState.irrigationZoneEmitterIds,
      interval: formState.interval,
      fieldAssetStoreState: fieldAssetStore.getState(),
    })
  }, [
    formState.propertyId,
    formState.points,
    formState.blockIds,
    formState.irrigationZoneEmitterIds,
    formState.interval,
  ])
}
